import { PlPrequalOfferModuleController } from 'partial/OfferManager/modules/PlPrequalOfferModule/PlPrequalOfferModuleController';

export default PlPrequalOfferModuleController;
